<template lang="html">
  <main class="row">

    <div v-if="details.ready" class="col-12 col-md-8 offset-md-2 text-center">

      <h4>Detalles de la compra</h4>

      <div class="buy-delivery-details row">

        <!-- Title -->
        <div class="col-4 text-left pt-3"> Producto </div>
        <div class="col-8 text-right pt-3"> {{details.title}} </div>

        <!-- Unit price -->
        <div class="col-7 text-left pt-3"> Precio por unidad </div>
        <div class="col-5 text-right pt-3"> {{ priceBuyUnit | currency }} </div>

        <!-- Buying units price -->
        <div class="col-8 text-left pt-3"> Cantidad a comprar </div>
        <div class="col-4 text-right pt-3"> {{ quantity }} </div>

        <!-- Total price -->
        <div class="col-6 text-left pt-3"> Total a pagar </div>
        <div class="col-6 text-right pt-3"> {{ totalToPay.toFixed(2) | currency }} </div>

      </div>

      <!-- Shipping -->
      <template v-if="delivery.street != ''" >

        <!-- Dirección de envío -->
        <h4 class="mt-4"> Dirección de Envío</h4>

        <div class="buy-delivery-details row">
          <div class="col-12 text-center">
            <div>
              {{ delivery.string }}
            </div>
          </div>
        </div>


        <!-- Delivery note -->
        <template>
          <h4 class="mt-4"> Nota </h4>

          <div class="buy-delivery-details row">
            <div class="col-12 text-center">
              {{ delivery.description }}
            </div>
          </div>
        </template>



        <!-- Recipient -->
        <h4 class="mt-4"> Receptor</h4>

        <div class="buy-delivery-details row">
          <div class="col-12 text-center">
            {{ delivery.recipient.name }}
            {{ formatPhone(delivery.recipient.phone) }}
          </div>
        </div>

      </template>


    </div>

    <div class="buy-buttons col-sm-12">

      <SquaredButton
        @click="prevTab"
        styleType="link"
        label="Anterior"
      />

      <SquaredButton
        @click="nextTab"
        styleType="primary"
        label="Pagar"
        :disabled="isFetching"
      />

    </div>

  </main>
</template>

<script>
import store from '@/store'
import {filterNumbersOnly, formatPhone} from '@/helpers'
import {instance as snack} from '@/components/layout/SnackMessage'

export default {
  props: {
    shippingType: String
  },

  data: () => ({
  }),

  computed: {

    isFetching: () => store.state.isFetching,

    details: () => store.getters['publication/preview'],

    quantity: () => store.state.buy.quantity,

    priceBuyUnit: () => store.state.buy.price_buy_unit,

    totalToPay: () => store.state.buy.total_to_pay,

    initPoint: () => store.state.buy.order.init_point,

    user: () => store.state.user,

    delivery: () => store.state.buy.delivery,
  },

  methods: {
    formatPhone,
    prevTab () {
      if(this.shippingType == 'INCLUDED_IN_PRICE')
        this.$emit('goToDelivery')
      else
        this.$emit('goToQuantity')
    },
    nextTab () {
      store.dispatch('setIsFetching', true)
      store.dispatch('buy/getInitPoint', store.state.buy.order.id)
        .then((res) => {
          window.location.href = this.initPoint;
        })
        .catch(error => {
          if (error.response.status === 409) {
            this.showMessage(
              'Ocurrió un error',
              "El vendedor se quedó sin stock del producto solicitado",
              "error"
            )
          }
        })
        .finally(
          store.dispatch('setIsFetching', true)
        );
    },

    showMessage ($title, $message, $theme) {
      snack({
        title: $title,
        text: $message,
        theme: $theme,
        timeout: 5000
      })
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
  .buy-delivery-details{
    background-color: #F7F6F6;
      border-radius: 4px;
      padding: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/marketplace/tabs/TabConfirmation.vue